import { RechtlicheInformationenStore } from './rechtliche-informationen.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export const selectRechtlicheInformationenState = createFeatureSelector<RechtlicheInformationenStore>('rechtlicheInformationen');

export const selectImpressumHtml = createSelector(selectRechtlicheInformationenState, (state: RechtlicheInformationenStore) => state.impressumHtml);

export const selectError = createSelector(selectRechtlicheInformationenState, (state: RechtlicheInformationenStore) => state.error);
